'use client'

import { StoryTitle as StoryTitleComponent } from '@news12/storybook-news'

import React, { useCallback, useMemo } from 'react'

import useRegion from '../../hooks/useRegion'
import { TopStory } from '../../types'

type StoryTitleProps = {
  story: TopStory
}

const StoryTitle = ({ story }: StoryTitleProps) => {
  const region = useRegion()

  const originalPublishedAt = useMemo(() => new Date(story.originalPublishedAt), [story])
  const publishedAt = useMemo(() => new Date(story.publishedAt), [story])

  const handleShare = useCallback(
    (method: string) => {
      const url = `https://${region.name}.news12.com/${story?.slug}`

      switch (method) {
        case 'link': {
          navigator.clipboard.writeText(url)
          break
        }
        case 'facebook': {
          window.open(`https://www.facebook.com/sharer/sharer.php?u=${url}`, '_blank')
          break
        }
        case 'twitter': {
          window.open(`https://twitter.com/share?url=${url}`, '_blank')
          break
        }
      }
    },
    [region, story]
  )

  return (
    <StoryTitleComponent
      title={story.title}
      subTitle={story.description}
      authors={story.authorsData}
      date={originalPublishedAt}
      updatedAt={publishedAt}
      onShare={handleShare}
    />
  )
}

export default StoryTitle
